type MaybeString = string | null | undefined | "";

export function isStringEmpty(str: MaybeString) {
  return str === undefined || str === null || str === "";
}

export function isNotStringEmpty(str: MaybeString) {
  return !isStringEmpty(str);
}

export function isEmail(str: string) {
  let re =
    /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return re.test(String(str).toLowerCase());
}

export const validationRules = {
  givenName: [isNotStringEmpty],
  familyName: [isNotStringEmpty],
  email: [isNotStringEmpty, isEmail],
};

interface ValidationRules {
  [key: string]: any;
}

interface State {
  [key: string]: any;
}

export interface ValidationState {
  [key: string]: boolean;
}

type ValidationFn = (value: any) => boolean;

export const validateWith =
  (rules: ValidationRules) =>
  (state: State): ValidationState => {
    return Object.keys(rules).reduce(
      (validationState: ValidationState, validationKey: string) => {
        const value = state[validationKey];
        const fns = rules[validationKey];

        const validationResult: boolean = fns.reduce(
          (acc: ValidationState, fn: ValidationFn) => {
            let result = false;

            try {
              result = fn(value);
            } catch (err) {
              result = false;
            }

            return acc && result;
          },
          true
        );

        return {
          ...validationState,
          [validationKey]: validationResult,
        };
      },
      {}
    );
  };

export default validateWith(validationRules);
